import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getBankId } from 'actionCreators/search';

const withSaveResume = () => (WrappedComponent) => {
  const WithSaveResume = ({ ...props }) => {
    useEffect(() => {
      const {
        getBankId,
        config: { bankId, accessToken, loanType }
      } = props;

      if (accessToken && !bankId) {
        /**
         * if loanType is not resume, assume the user IS an Existing Customer.
         */
        getBankId(loanType !== 'resume', loanType);
      }
    });
    return <WrappedComponent {...props} />;
  };

  withSaveResume.displayName = `WithSaveResume(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return connect(
    (state) => ({
      config: state.config
    }),
    (dispatch) => bindActionCreators({ getBankId }, dispatch)
  )(WithSaveResume);
};

export { withSaveResume };
